'use client'
import RecipeStepRepeater, {
  RecipeStepRepeaterProps,
} from '@/components/molecules/RecipeStepsRepeater'
import { NormalizedSection, TitleProps } from '@/types'
import { Section, Title } from '@dynamo-caffeina-dev/airc-ui-kit'

export interface RecipeStepsProps extends NormalizedSection {
  modelledContent: {
    title: TitleProps
    recipeStepRepeater: RecipeStepRepeaterProps['content']
  }
}

function RecipeSteps({ modelledContent }: RecipeStepsProps) {
  const { title, recipeStepRepeater } = modelledContent
  const titleLabel = title.content || ''
  return (
    <Section className='section-recipe-steps'>
      <div className='section-recipe-steps__content-wrapper'>
        {title && titleLabel ? (
          <Title
            className={'section-recipe-steps__content-wrapper__title'}
            {...title}
            as={'h2'}
            dangerouslySetInnerHTML={{ __html: titleLabel }}
          />
        ) : null}
        {recipeStepRepeater?.length ? (
          <RecipeStepRepeater
            className='section-recipe-steps__content-wrapper__repeater'
            content={recipeStepRepeater}
          />
        ) : null}
      </div>
    </Section>
  )
}

export default RecipeSteps
